.ek{background:var(--palette-white);}